/*
创建者 魏强(2018.1.30)
中华老字号 优选特推
*/
<template>
  <div class="wrapper">
    <div class="squares">
      <ul class="list_pic clearfix">
        <li v-handle-hover class="item" v-for="item in data" :key="item.goodsId">
          <div class="goods-content">
            <div class="goods-pic">
              <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                <img :src="item.thumbnail" :alt="item.name" />
              </router-link>
            </div>
            <div class="goods-info">
              <div class="goods-pic-scroll-show">
                <div class="ul">
                  <img :src="item.thumbnail" height="28" width="28" border="0">
                </div>
              </div>
              <div class="goods-name">
                <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                  {{item.name}}
                </router-link>
              </div>
              <div class="goods-price">
                <em class="sale-price" :title="'原价：¥'+item.mktPrice">{{item.price}}</em>
              </div>
              <div class="sell-stat">
                <ul>
                  <li>
                    <a href="javascript:void(0)" onclick="return false;" class="status">{{item.buyNum?item.buyNum:0}}</a>
                    <p>商品销量</p>
                  </li>
                  <li>
                    <a href="javascript:void(0)" onclick="return false;">{{item.commentNum?item.commentNum:0}}</a>
                    <p>用户评论</p>
                  </li>
                </ul>
              </div>
              <div class="store">
                <router-link :to="{path:'/shop',query:{tab:1,store_id:item.storeId}}" target="_blank">
                  店铺：{{item.storeName}}
                </router-link>
              </div>
              <div class="add-cart">
                <a href="javascript:void(0);" @click.stop.prevent="cAddCart(item.goodsId)" class="add_cart">加入菜篮</a>
                <a href="javascript:void(0);" @click.stop.prevent="buynow(item.goodsId,item.storeId,item)" class="buynow" title="立即购买"> 立即购买
                </a>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-show="total>0" class="page-wrapper">
      <Page :total="total" :current.sync="pageNo" :page-size="pageSize" show-elevator show-total @on-change="changePage"></Page>
    </div>

  </div>

</template>
<script>
import { getNtsxData } from 'api/home';
import { cartBuy } from 'api/goodsCart'
import { mapGetters } from 'vuex';
export default {
  props: ["list"],
  data() {
    return {
      pageNo: 1,
      pageSize: 8,
      data: [],
      total: 0,
      cat_id: "",

    }
  },
  computed: {
    ...mapGetters([
      'sid', 'name', 'signed'
    ]),
    // 计算是否已登陆
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    }

  },
  directives: {
    handleHover(el) {
      $(el).hover(
        function () {
          $(el).find(".goods-info").animate({ "top": "150px" }, 400, "swing");
        }, function () {
          $(el).find(".goods-info").stop(true, false).animate({ "top": "230px" }, 400, "swing");
        });
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "农特生鲜内容") {
        this.pageNo = 1;
        this.data = [];
        this.cat_id = this.$route.params.cat_id;
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    changePage(index) {
      this.pageNo = index;
      this.fetchData();
    },
    fetchData() {
      const pageNo = this.pageNo;
      const categoryId = this.cat_id || this.$route.params.cat_id || 3;
      const pageSize = this.pageSize;
      getNtsxData(pageNo, categoryId, pageSize).then(json => {
        if (json.resCode == 1) {
          let goodsList = json.data;
          this.data = goodsList.list;
          this.total = goodsList.total;
          this.pageNo = goodsList.pageNum;
        }
      });
    },
    buynow(goodsId, storeId, item) {
      if (this.isLogin) {
        let minNum = item.min_buy_num > 1 ? item.min_buy_num : 1
        cartBuy({
          buyFlag: 1,
          goodsId: goodsId,
          goodsNum: minNum
        }).then(res => {
          if (res.resCode === 1) {
            this.$router.push({
              path: '/checkout',
              query: {
                storeId: storeId,
                //itemId: res.data.itemId,
                num: minNum,
                goodsId: goodsId,
                coupon: res.data.coupon,
                chainGoodsProfit: res.data.chainGoodsProfit,
                checkAtTheShoppingPv: res.data.checkAtTheShoppingPv,
                couponLimit: res.data.checkAtTheCoupon,
                selfShoppingPv: res.data.selfShoppingPv
              }
            })
          } else {
            this.$Message.info(res.resDesc);
          }
        })
      } else {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，游客身份不能购买商品！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      }
    },
    // 添加购物车
    cAddCart(goodsId) {
      if (this.isLogin) {
        this.$store.dispatch('addCart', {
          id: goodsId,
          num: 1
        }).then(res => {
          if (res.resCode === 1) {
            this.$Message.info('成功加入购物车');
          } else {
            this.$Message.info(res.resDesc);
          }
        })
      } else {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，游客身份不能加入购物车！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      }
    }
  }
}
</script>
<style scoped>
#huiju-wrapper ul li img {
  height: 278px;
  width: 328px;
}
.page-wrapper {
  margin: 20px 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// content-item.vue?5bc70f84